import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { lastRouteState } from './types';

type State = {
  lastRoute?: lastRouteState;
};

const initialState: State = {
  lastRoute: undefined
};

const slice = createSlice({
  name: 'last-route',
  initialState,
  reducers: {
    addLastRoute: (state, action: PayloadAction<lastRouteState>) => {
      console.log('Reducer called with:', action.payload);
      state.lastRoute = action.payload;
    },
    clearLastRoute: (state) => {
      state.lastRoute = undefined;
    }
  }
});

export const reducer = slice.reducer;

export const actions = {
  ...slice.actions
};
